import { ComplianceRepository } from "../../repositories/ComplianceRepository";
import { MasterComplianceCalendarEntity } from "../../entities/MasterComplianceCalendarEntity";

export class CreateCalendarEntryUseCase {
  constructor(private repository: ComplianceRepository) {}

  async execute(data: Partial<MasterComplianceCalendarEntity>): Promise<MasterComplianceCalendarEntity> {
    // Validation
    if (!data.compliance_type_id) {
      throw new Error("Compliance type ID is required");
    }
    if (!data.compliance_form_name) {
      throw new Error("Compliance form name is required");
    }
    if (!data.period) {
      throw new Error("Period is required");
    }
    if (!data.period_start_date) {
      throw new Error("Period start date is required");
    }
    if (!data.period_end_date) {
      throw new Error("Period end date is required");
    }
    if (!data.due_date) {
      throw new Error("Due date is required");
    }
    if (!data.authority) {
      throw new Error("Authority is required");
    }

    return await this.repository.createCalendarEntry(data);
  }
}

